import {defineComponent} from "vue";
import {FALLBACK_TRANSLATIONS} from "../Utils/FallbackTranslations";

export default defineComponent({
		computed: {
			// @ts-ignore
			languages() {
				// @ts-ignore
				return this.$root.languagesStore.languageList;
			},
			// @ts-ignore
			translateList() {
				// @ts-ignore
				return this.$root.languagesStore.translateList;
			}
		},
		methods: {
			// @ts-ignore
			translate(key: string, params?: { [propName: string]: any }): string {
				// The base language texts only where the translations of the server could not be loaded
				// @ts-ignore
				const fallback = this.$root.languagesStore.hasFailed ? FALLBACK_TRANSLATIONS[key] : undefined;
				if (params && Object.keys(params)?.length > 0) {
					let result = this.translateList[key] ?? fallback ?? key;
					if (result !== key) {
						const keys = Object.keys(params);
						keys.forEach(translateKey => {
							if (result.includes(translateKey)) {
								result = result.replace('{' + translateKey + '}', params[translateKey]);
							}
						});
					}
					return result;
				}
				// @ts-ignore
				return this.translateList[key] ?? fallback ?? key;
			},
		},
	}
);
